import { Component, EventEmitter, forwardRef, OnDestroy, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, ValidationErrors, Validator } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { PORTFOLIO_RIGHTS } from '../../../display-product-data/pump-data.model';

@Component({
    selector: 'app-pump-system-portfolio',
    templateUrl: './pump-system-portfolio.component.html',
    styleUrls: ['./pump-system-portfolio.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PumpSystemPortfolioComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PumpSystemPortfolioComponent),
            multi: true
        }
    ],
    standalone: false
})
export class PumpSystemPortfolioComponent implements OnDestroy, ControlValueAccessor, Validator {
  portfolio_rights = PORTFOLIO_RIGHTS;

  selectedValues: string[] = [];
  private subscriptions: Subscription[] = [];

  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  selectListControl = new UntypedFormControl([]);

  // Handle selection from UI
  typeChangeAction(event: MatSelectChange) {
    this.selectedValues = event.value;
    this.selectionChange.emit(event);
  }

  // model --> view
  writeValue(value: string[] | null): void {
    if (Array.isArray(value)) {
      this.selectedValues = value;
      this.selectListControl.setValue(value, { emitEvent: false });
    } else {
      this.selectedValues = [];
      this.selectListControl.reset([]);
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
  return null;
}


  // view --> model
  registerOnChange(fn: (value: string[]) => void) {
    const sub = this.selectListControl.valueChanges.subscribe(fn);
    this.subscriptions.push(sub);
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  onTouched: () => void = () => {};

  setDisabledState?(isDisabled: boolean): void {
  if (isDisabled) {
    this.selectListControl.disable({ emitEvent: false });
  } else {
    this.selectListControl.enable({ emitEvent: false });
  }
}
  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
